<style scoped lang="scss">
.mobile-editor {
  cursor: pointer;
  font-size: 14px;
  margin-left: 5px;
}
.tag-users {
  padding-bottom: 10px;
  line-height: 1.2;
  .icon-user-circle1 {
    margin-right: 10px;
    font-size: 24px;
    color: #ccc;
  }
}
.selected-tags {
  padding-top: 15px;
  margin-bottom: 15px;
  border-top: 1px solid #efefef;
  border-bottom: 1px solid #efefef;
  .label {
    margin-bottom: 15px;
  }
  .el-tag {
    margin-right: 10px;
    margin-bottom: 15px;
  }
}
.tag-item {
  cursor: pointer;
  color: #666;
  border-color: #dadadd;
  margin-right: 10px;
  margin-top: 10px;
}
</style>

<template>
  <div>
    <div >
      <el-row :gutter="10" >
        <el-col :md="6" :lg="5">
          <el-input placeholder="手机号" v-model="params.connact_mobile" clearable  size="mini">
            <el-button slot="append" icon="el-icon-search" @click="Search"></el-button>
          </el-input>
        </el-col>
        <el-col :md="6" :lg="5">
          <el-input placeholder="真实姓名" v-model="params.realname" clearable  size="mini">
            <el-button slot="append" icon="el-icon-search" @click="Search"></el-button>
          </el-input>
        </el-col>
        <el-col :md="6" :lg="8" >
        <el-select  v-model="params.flag" placeholder="实名等级" clearable @change="getFlagChange" size="mini" >
          <el-option
            v-for="item in flagList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
          <el-select  v-model="params.verify" @change="getVerifyChange" clearable  placeholder="审核" size="mini" >
            <el-option
              v-for="item in verifyList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-table :data="dataList"   height="800px" v-loading="loading">
        <el-table-column prop="id"   label="id" width="130"></el-table-column>
        <el-table-column prop="realname" label="真实姓名" ></el-table-column>
        <el-table-column prop="connact_mobile" label="联系方式" ></el-table-column>
        <el-table-column prop="identity" label="身份证号码" ></el-table-column>
        <el-table-column prop="postname" label="传递实名名称" ></el-table-column>
        <el-table-column prop="postidcard" label="传递身份证号码" ></el-table-column>
        <el-table-column prop="flag" label="实名等级" width="180">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.flag==0" type="error">未实名</el-tag>
            <el-tag v-if="scope.row.flag==1 && scope.row.verify == 0" type="success">一级实名已审核</el-tag>
            <el-tag v-if="scope.row.flag==1 && scope.row.verify == 1" type="error">二级实名待审核</el-tag>
            <el-tag v-if="scope.row.flag==2 && scope.row.verify == 0" type="success">二级实名已审核</el-tag>
            <el-tag v-if="scope.row.flag==2 && scope.row.verify == 1" type="error">二级实名待审核</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="created" v-if="false" label="时间" >
          <template slot-scope="scope">
            <el-tooltip placement="top">
              <div slot="content">注册时间<br/>{{scope.row.created|datetime('yyyy-MM-dd hh:mm:ss')}}</div>
              <span>{{scope.row.created|datetime}}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="380">
          <template slot-scope="scope">
            <el-button type="text" @click="toEdit(scope.row)">审核</el-button>
            <el-button type="text" @click="toLog(scope.row)">操作日志</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog
        title="审核"
        :visible.sync="editDialog"
        width="50%"
        :close-on-click-modal="false"
        :before-close="handleClose">
        <el-form :model="form" >
          <el-form-item label="真实名称" label-width="15%">
            <el-input v-model="form.realname"     autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="手机号" label-width="15%">
            <el-input v-model="form.connact_mobile" readonly    autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="身份证号码" label-width="15%">
            <el-input v-model="form.identity"  readonly   autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="传递实名名称" label-width="15%">
            <el-input v-model="form.postname"  autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="传递实名身份证" label-width="15%">
            <el-input v-model="form.postidcard"  readonly   autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="身份证正面/反面" readonly   label-width="15%" >
            <div class="demo-image__preview">
              <el-image
                style="width: 200px; height: 150px"
                :src="form.front_photo"
                :preview-src-list="[form.front_photo,form.reverse_photo]">
              </el-image>
              <el-image
                style="width: 200px; height: 150px"
                :src="form.reverse_photo"
                :preview-src-list="[form.front_photo,form.reverse_photo]"
                >
              </el-image>
            </div>
          </el-form-item>

          <el-form-item label="实名认证" label-width="15%">
            <el-select v-model="form.flag"  placeholder="请选择">
              <el-option
                 v-for="item in flagList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="审核" label-width="15%">
            <el-select v-model="form.verify" placeholder="请选择">
              <el-option
                v-for="item in verifyList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="未通过原因" v-if="form.verify== 1 " label-width="15%">
            <el-input
              type="textarea"
              :rows="3"
              placeholder="请输入未通过原因"
              v-model="message">
            </el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
    <el-button @click="handleClose">取 消</el-button>
    <el-button type="primary" @click="submit">确 定</el-button>
  </span>
      </el-dialog>
        <el-dialog
            title="操作日志"
            :visible.sync="logDialog"
            width="50%"
            :close-on-click-modal="false"
            :before-close="loghandleClose">
          <el-table :data="datalogList"   height="500px" v-loading="logloading">
          <el-table-column prop="id"   label="id" width="130"></el-table-column>
          <el-table-column prop="user_id" label="操作id" width="130"></el-table-column>
          <el-table-column prop="overseas_drug_id" label="实名id" width="130"></el-table-column>
          <el-table-column prop="verify" label="审核" width="80">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.verify==0" type="success">已审核</el-tag>
              <el-tag v-if="scope.row.verify==1" type="error">未通过</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="message" label="原因备注" ></el-table-column>
          <el-table-column prop="created"  label="操作日期" >
            <template slot-scope="scope">
              <el-tooltip placement="top">
                <div slot="content">操作日期<br/>{{scope.row.created|datetime('yyyy-MM-dd hh:mm:ss')}}</div>
                <span>{{scope.row.created|datetime('yyyy-MM-dd hh:mm:ss')}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          </el-table>
      </el-dialog>


      <div v-if="total_count > params.pageSize" class="content-padded tc">
        <el-pagination background   layout="prev, pager, next, total" @current-change="handleCurrentChange" :current-page.sync="params.page" :total='total_count' :page-size='params.pageSize'>
        </el-pagination>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import {getAuditmemberList,getAuditmemberUpdate,getAuditmemberLogList} from '../../../api/auditmember'

export default {
  components: {

  },

  data() {
    return {
      formdata:'',
      total_count:0,
      loading:false,
      connact_mobile:'',
      realname:'',
      flag:'',
      verify:'',
      message:'',
      params:
        {
          page: 1,
          pageSize:20,
          connact_mobile:'',
          realname:'',
          flag:'',
          verify:'',
        },
      dataList: [],
      datalogList:[],
      flagList: [
        {label: '未实名',value: 0},
        {label: '一级实名',value: 1},
        {label: '二级实名',value: 2}
      ],
      verifyList:[
        {label: '已审核',value: 0},
        {label: '未通过',value: 1}
      ],
      editDialog: false,
      logDialog:false,
      logloading:false,
      url:'',
      srcList:[],
      form:{},
    }
  },
  computed: {
  },

  methods: {
    toEdit(e){
      console.log(e,'11111111111111')
      this.editDialog = true
      this.form=e;
      this.url=e.front_photo;
      this.srcList=[e.front_photo,e.reverse_photo];
    },
    handleClose(e){
      this.editDialog=false;
    },
    loghandleClose(e){
      this.logDialog=false;
    },
    submit(){
      var arr={
        id:this.form.id,
        user_id:this.form.user_id,
        flag:this.form.flag,
        realname:this.form.realname,
        postname:this.form.postname,
        verify:this.form.verify,
        message:this.message,
      }
      getAuditmemberUpdate(arr).then(response => {
          if(response){
            this.$message({
              type: 'success',
              message:'更新成功！'
            })
            this.editDialog=false;
          }else{
            this.$message({
              type: 'error',
              message:'更新失败'
            })
          }
      })
    },
    toLog(row){
      this.logDialog=true;
      this.logloading = true
          let param={
            overseas_drug_id:row.id,
            pageSize:20,
            page:1,
          };
          getAuditmemberLogList(param).then(response => {
            this.datalogList = response.data.data.list
            this.logloading = false
          })
    },
    getParams() {
      if (this.realname) {
        this.params.realname = this.realname
      }
      if (this.connact_mobile) {
        this.params.connact_mobile = this.connact_mobile
      }
      if (this.flag) {
        this.params.flag = this.flag
      }
      if (this.verify) {
        this.params.verify = this.verify
      }
    },
    getList(filter) {
      this.loading = true
      filter.pageSize = 20;
      getAuditmemberList(filter).then(response => {
        this.dataList = response.data.data.list
        this.total_count=response.data.data.total_count
        this.loading = false
      })
    },
    Search(){
      this.getParams()
      this.params.page=1;
      this.getList(this.params);
    },
    getFlagChange(e){
      this.params.flag=e;
      this.params.page=1;
      this.getList(this.params);
    },
    getVerifyChange(e){
      this.params.verify=e;
      this.params.page=1;
      this.getList(this.params);
    },
    handleCurrentChange(val){
      this.params.page = val
      this.getParams()
      this.getList(this.params)
    }
  },
  mounted () {

    this.getParams();
    this.getList(this.params)

  }
}
</script>



// WEBPACK FOOTER //
// auditmember.vue?62a0d3fb